import { useLocalStoreWithDep } from "designSystem/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { MultiSelectComponent } from "../index";
import { useGoToDialogSave } from "../select/hooks";
import { RefContainerStore } from "./RefContainerStore";
import { RefProps } from "./RefStoreBase";

export const RefContainer: FunctionComponent<RefProps> = observer(({ attributeId, nodeType, nodeUrl, reportOperations }) => {
	const refContainerStore = useLocalStoreWithDep(() => new RefContainerStore(attributeId, nodeType, nodeUrl, reportOperations), [reportOperations]);
	const { store } = refContainerStore || {};
	const goToDialogSave = useGoToDialogSave();

	return (
		<MultiSelectComponent aggregateStore={store} goToDialogSave={goToDialogSave} />
	);
});
